export const getEventAccess = (event) => {
  if (!event) {
    return {
      isPrivate: false,
      isFreeEntry: false,
      isInternalTickets: true,
      isExternalTickets: false,
      externalTicketUrl: null,
    };
  }

  const isPrivate = !!(event.is_private || event.visibility === 'private');
  const isFreeEntry = !isPrivate && !!(event.is_free_entry || event.entry_type === 'free');
  const isExternalTickets = !isPrivate && !isFreeEntry && !!(
    event.is_external_tickets || event.ticket_source === 'external'
  );
  const isInternalTickets = !isPrivate && !isFreeEntry && !isExternalTickets;

  return {
    isPrivate,
    isFreeEntry,
    isInternalTickets,
    isExternalTickets,
    externalTicketUrl: event.external_ticket_url || null,
  };
};

export const formatCityCountry = (event) => {
  if (!event) return '';
  return [event.city, event.country].filter(Boolean).join(', ');
};

export const formatPublicLocation = (event, access = getEventAccess(event)) => {
  if (!event) return '';
  if (access.isPrivate) return formatCityCountry(event);
  return event.venue || formatCityCountry(event);
};

export const openExternalTicketUrl = (url) => {
  if (!url) return;
  window.open(url, '_blank', 'noopener,noreferrer');
};
